import {Mix} from "../core/Reflection";
import {Button, PulsatingButton} from "./Button";

export class SplashPlayButton extends Mix(Button, PulsatingButton) {
}
